import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2,ViewChild, ElementRef } from '@angular/core';


import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';
import * as xlsx from 'xlsx';


@Component({
  selector: 'app-file-matrix',
  templateUrl: './file-matrix.component.html',
  styleUrls: ['./file-matrix.component.css']
})
export class FileMatrixComponent implements OnInit {
	@ViewChild('epltable', { static: false }) epltable: ElementRef;
	respObject: any;
	fileData: any;
  compObj: any;
  compData: any;

  dataType = "";
  fileYear="";
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  filefYear="";
  selectMonth="";
  fileQuarter="";
  companyId="";
  downLoadPath=this._rest.FILE_PATH;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;
  resultData = {"gen":[],"spl":[],"stand":[],"genSum":{},"splSum":{},"standSum":{},"industry":{}}
  dataTypeErr = "";
  yrErr = "";
  months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  months1 = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  quaters = ["Q1","Q2","Q3","Q4"];
  totRows = 0;
  tabData = [];
  curTimeStr = "";
  fltrStr = "";
  showDownload=false;
  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
    this.dataType = "";
    this.selectMonth="";
    this.fileQuarter="";
    this.companyId="";
    this.curPage= 1;
    for (var i= this.fullYear+1;i>=this.fullYear-10;i--){
      this.yearArr.push(i);
      this.fileYear= i+"";
    }
    for (var i= this.fullYear;i>=this.fullYear-10;i--){
      this.yearfArr.push(i+"-"+(i+1));
      this.filefYear = i+"-"+(i+1);
    }
    this.dataType="Segment";
	this.fileYear=this.fullYear +"";
	this.filefYear=this.fullYear +"-"+(this.fullYear +1);
    const cRData = {}
    this._rest.companyList(cRData).subscribe((res) => {
    	console.log(res)
      this.compObj = res;
      this.compData = this.compObj.details;  
      this.searchFile(1);    
    });
    
    
  	
  }
  
  toBld(str){
  	return "<strong>"+str+"</strong>";
  }

  toBld1(str){
    return "<strong class='tableheader' style='margin-right: 30px; margin-left: 510px; background: #fff; border-bottom: 1px solid #e8e9ed; box-shadow: none; margin-top: 170px; padding: 100 30px; position: fixed; left: 0; right: 0; top: 0; z-index: 999;'>"+str+"</strong>";
  }
  searchFile(curPage){
  	this.showDownload=false;
  	this.tabData = [];
  	var fd = {};
  	var currentdate = new Date(); 
	this.curTimeStr = "As On: " + currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/" 
                + currentdate.getFullYear() + " "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();

    var details = "Details: "+this.dataType+" - Data Report - ";
  	this.resultData = {"gen":[],"spl":[],"stand":[],"genSum":{"insurer":"General Insurers Sub Total"},"splSum":{"insurer":"Specialised Insurers Sub Total"},"standSum":{"insurer":"Stand-alone Health sub Total"},"industry":{"insurer":"Industry Total"}};

  	if(this.dataType == "Segment"){
	      for(let j=0;j<this.months.length;j++){
	      	this.resultData.genSum[this.months[j]] = 0;
	      	this.resultData.splSum[this.months[j]] = 0;
	      	this.resultData.standSum[this.months[j]] = 0;
	      	this.resultData.industry[this.months[j]] = 0;
	      }
	      this.totRows = 13;
	      details = details+this.fileYear;
	      fd["year"] = this.fileYear;

    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
      for(let j=0;j<this.quaters.length;j++){
      	this.resultData.genSum[this.quaters[j]] = 0;
      	this.resultData.splSum[this.quaters[j]] = 0;
      	this.resultData.standSum[this.quaters[j]] = 0;
      	this.resultData.industry[this.quaters[j]] = 0;
      }
      details = details+this.filefYear;
      fd["year"] = this.filefYear;
       this.totRows = 5;
    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){  
    	this.resultData.genSum["year"] = 0;
      	this.resultData.splSum["year"] = 0;
      	this.resultData.standSum["year"] = 0;  
      	this.resultData.industry["year"] = 0;   
       	this.totRows = 2;
       	details = details+this.filefYear;
       	fd["year"] = this.filefYear;
    }
    this.fltrStr = details;

	fd["dataType"] = this.dataType;
  	for(let i=0;i<this.compData.length;i++){
  		let tmpData = {};
  		tmpData["insurer"] = this.compData[i].companyName;
  		tmpData["companyId"] = this.compData[i].companyId;
  		if(this.dataType == "Segment"){
	      for(let j=0;j<this.months.length;j++){
	      	tmpData[this.months[j]] = 0;
	      }
	    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
	      for(let j=0;j<this.quaters.length;j++){
	      	tmpData[this.quaters[j]] = 0;
	      }
	    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){     
	      tmpData["year"] = 0;
	    }
  		if(this.compData[i].industryType=="General"){	
  			this.resultData.gen.push(tmpData);
  		} else if(this.compData[i].industryType=="Specialized"){
  			this.resultData.spl.push(tmpData);  			
  		} else if(this.compData[i].industryType=="Standalone Health"){
  			this.resultData.stand.push(tmpData);
  		} 
  	}
  	
  	
  	this._rest.fileMatrix(fd).subscribe((res) => {
      this.respObject = res;
      if(this.respObject.error==0){
        this.fileData=this.respObject.resp;
        for(let i=0;i<this.fileData.length;i++){
        	if(this.fileData[i].industryType=="General"){
        		if(this.dataType == "Segment"){
	        		for(let j=0;j<this.resultData.gen.length;j++){
	        			if(this.resultData.gen[j].companyId==this.fileData[i].companyId){
	        				this.resultData.gen[j][this.fileData[i].monthly] = 1;
	        			}
	        		}
	        	} else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){  
	        		for(let j=0;j<this.resultData.gen.length;j++){
	        			if(this.resultData.gen[j].companyId==this.fileData[i].companyId){
	        				this.resultData.gen[j][this.fileData[i].quarterly] = 1;
	        			}
	        		}
	        	} else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){  
	        		for(let j=0;j<this.resultData.gen.length;j++){
	        			if(this.resultData.gen[j].companyId==this.fileData[i].companyId){
	        				this.resultData.gen[j]["year"] = 1;
	        			}
	        		}   
	        	}
        	} else if(this.fileData[i].industryType=="Specialized"){
        		if(this.dataType == "Segment"){
	        		for(let j=0;j<this.resultData.spl.length;j++){
	        			if(this.resultData.spl[j].companyId==this.fileData[i].companyId){
	        				this.resultData.spl[j][this.fileData[i].monthly] = 1;
	        			}
	        		}
	        	} else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){  
	        		for(let j=0;j<this.resultData.spl.length;j++){
	        			if(this.resultData.spl[j].companyId==this.fileData[i].companyId){
	        				this.resultData.spl[j][this.fileData[i].quarterly] = 1;
	        			}
	        		}
	        	} else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){  
	        		for(let j=0;j<this.resultData.spl.length;j++){
	        			if(this.resultData.spl[j].companyId==this.fileData[i].companyId){
	        				this.resultData.spl[j]["year"] = 1;
	        			}
	        		}   
	        	}

        	} else if(this.fileData[i].industryType=="Standalone Health"){
        		if(this.dataType == "Segment"){
	        		for(let j=0;j<this.resultData.stand.length;j++){
	        			if(this.resultData.stand[j].companyId==this.fileData[i].companyId){
	        				this.resultData.stand[j][this.fileData[i].monthly] = 1;
	        			}
	        		}
	        	} else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){  
	        		for(let j=0;j<this.resultData.stand.length;j++){
	        			if(this.resultData.stand[j].companyId==this.fileData[i].companyId){
	        				this.resultData.stand[j][this.fileData[i].quarterly] = 1;
	        			}
	        		}
	        	} else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){  
	        		for(let j=0;j<this.resultData.stand.length;j++){
	        			if(this.resultData.stand[j].companyId==this.fileData[i].companyId){
	        				this.resultData.stand[j]["year"] = 1;
	        			}
	        		}   
	        	}
        	}
        }
       let tmpdd = [];
       //tmpdd.push(this.curTimeStr);
       /*for(let i=0;i<this.totRows-1;i++){
       	tmpdd.push("");
       }*/
       //this.tabData.push(tmpdd);
      	//tmpdd = [];
       //tmpdd.push(this.fltrStr);
       /*for(let i=0;i<this.totRows-1;i++){
       	tmpdd.push("");
       }
       this.tabData.push(tmpdd);*/
       //tmpdd = [];
       tmpdd.push(this.toBld1("Insurer"));
        if(this.dataType == "Segment"){
        	for(let j=0;j<this.months.length;j++){
        		tmpdd.push(this.toBld1(this.months1[j]));
        	}
        	this.tabData.push(tmpdd);
        	tmpdd = [];
       		tmpdd.push(this.toBld("General Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
        	for(let i=0;i<this.resultData.gen.length;i++){
        		tmpdd = [];
        		tmpdd.push(this.resultData.gen[i].insurer);
	        	for(let j=0;j<this.months.length;j++){
	        		tmpdd.push(this.resultData.gen[i][this.months[j]]+"");
	        		this.resultData.genSum[this.months[j]] = this.resultData.genSum[this.months[j]]+this.resultData.gen[i][this.months[j]];
	        		this.resultData.industry[this.months[j]] = this.resultData.industry[this.months[j]]+this.resultData.gen[i][this.months[j]]
	        	}
	        	this.tabData.push(tmpdd);
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.genSum["insurer"]));
	        for(let j=0;j<this.months.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.genSum[this.months[j]]));
	        }
	        this.tabData.push(tmpdd);
	        tmpdd = [];
       		tmpdd.push(this.toBld("Stand-alone Health Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
	        for(let i=0;i<this.resultData.stand.length;i++){
	        	tmpdd = [];
        		tmpdd.push(this.resultData.stand[i]["insurer"]);
	        	for(let j=0;j<this.months.length;j++){
	        		tmpdd.push(this.resultData.stand[i][this.months[j]]+"");
	        		this.resultData.standSum[this.months[j]] = this.resultData.standSum[this.months[j]]+this.resultData.stand[i][this.months[j]];
	        		this.resultData.industry[this.months[j]] = this.resultData.industry[this.months[j]]+this.resultData.stand[i][this.months[j]]
	        	}
	        	this.tabData.push(tmpdd);
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.standSum["insurer"]));
	        for(let j=0;j<this.months.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.standSum[this.months[j]]));
	        }
	        this.tabData.push(tmpdd);
	        tmpdd = [];
       		tmpdd.push(this.toBld("Specialised Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
	        for(let i=0;i<this.resultData.spl.length;i++){
	        	tmpdd = [];
        		tmpdd.push(this.resultData.spl[i]["insurer"]);
	        	for(let j=0;j<this.months.length;j++){
	        		tmpdd.push(this.resultData.spl[i][this.months[j]]+"");
	        		this.resultData.splSum[this.months[j]] = this.resultData.splSum[this.months[j]]+this.resultData.spl[i][this.months[j]];
	        		this.resultData.industry[this.months[j]] = this.resultData.industry[this.months[j]]+this.resultData.spl[i][this.months[j]]
	        	}
	        	this.tabData.push(tmpdd);
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.splSum["insurer"]));
	        for(let j=0;j<this.months.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.splSum[this.months[j]]));
	        }
	        this.tabData.push(tmpdd);
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.industry["insurer"]));
	        for(let j=0;j<this.months.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.industry[this.months[j]]));
	        }
	        this.tabData.push(tmpdd);
        } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){  
        	for(let j=0;j<this.quaters.length;j++){
        		tmpdd.push(this.toBld(this.quaters[j]));
        	}
        	this.tabData.push(tmpdd);
        	tmpdd = [];
       		tmpdd.push(this.toBld("General Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
        	for(let i=0;i<this.resultData.gen.length;i++){
        		tmpdd = [];
        		tmpdd.push(this.resultData.gen[i].insurer);
	        	for(let j=0;j<this.quaters.length;j++){
	        		tmpdd.push(this.resultData.gen[i][this.quaters[j]]+"");
	        		this.resultData.genSum[this.quaters[j]] = this.resultData.genSum[this.quaters[j]]+this.resultData.gen[i][this.quaters[j]];
	        		this.resultData.industry[this.quaters[j]] = this.resultData.industry[this.quaters[j]]+this.resultData.gen[i][this.quaters[j]]
	        	}
	        	this.tabData.push(tmpdd);
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.genSum["insurer"]));
	        for(let j=0;j<this.quaters.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.genSum[this.quaters[j]]));
	        }
	        this.tabData.push(tmpdd);
	        tmpdd = [];
       		tmpdd.push(this.toBld("Stand-alone Health Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
	        for(let i=0;i<this.resultData.stand.length;i++){
	        	tmpdd = [];
        		tmpdd.push(this.resultData.stand[i]["insurer"]);
	        	for(let j=0;j<this.quaters.length;j++){
	        		tmpdd.push(this.resultData.stand[i][this.quaters[j]]+"");
	        		this.resultData.standSum[this.quaters[j]] = this.resultData.standSum[this.quaters[j]]+this.resultData.stand[i][this.quaters[j]];
	        		this.resultData.industry[this.quaters[j]] = this.resultData.industry[this.quaters[j]]+this.resultData.stand[i][this.quaters[j]];
	        	}
	        	this.tabData.push(tmpdd);
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.standSum["insurer"]));
	        for(let j=0;j<this.quaters.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.standSum[this.quaters[j]]));
	        }
	        this.tabData.push(tmpdd);
	        tmpdd = [];
       		tmpdd.push(this.toBld("Specialised Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
	        for(let i=0;i<this.resultData.spl.length;i++){
	        	tmpdd = [];
        		tmpdd.push(this.resultData.spl[i]["insurer"]);
	        	for(let j=0;j<this.quaters.length;j++){
	        		tmpdd.push(this.resultData.spl[i][this.quaters[j]]+"");
	        		this.resultData.splSum[this.quaters[j]] = this.resultData.splSum[this.quaters[j]]+this.resultData.spl[i][this.quaters[j]];
	        		this.resultData.industry[this.quaters[j]] = this.resultData.industry[this.quaters[j]]+this.resultData.spl[i][this.quaters[j]];
	        	}
	        	this.tabData.push(tmpdd);
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.splSum["insurer"]));
	        for(let j=0;j<this.quaters.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.splSum[this.quaters[j]]));
	        }
	        this.tabData.push(tmpdd);
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.industry["insurer"]));
	        for(let j=0;j<this.quaters.length;j++){
	        	tmpdd.push(this.toBld(this.resultData.industry[this.quaters[j]]));
	        }
	        this.tabData.push(tmpdd);
        } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){  
        	tmpdd.push(this.toBld(this.filefYear));
        	this.tabData.push(tmpdd);
        	tmpdd = [];
       		tmpdd.push(this.toBld("General Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
        	for(let i=0;i<this.resultData.gen.length;i++){
        		tmpdd = [];
        		tmpdd.push(this.resultData.gen[i].insurer);
        		tmpdd.push(this.resultData.gen[i]["year"]);
        		this.tabData.push(tmpdd);
        		this.resultData.genSum["year"] = this.resultData.genSum["year"]+this.resultData.gen[i]["year"];
        		this.resultData.industry["year"] = this.resultData.industry["year"]+this.resultData.gen[i]["year"]
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.genSum["insurer"]));
	        tmpdd.push(this.toBld(this.resultData.genSum["year"]));	        
	        this.tabData.push(tmpdd);
	        tmpdd = [];
       		tmpdd.push(this.toBld("Stand-alone Health Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
	        for(let i=0;i<this.resultData.stand.length;i++){
	        		tmpdd = [];
        			tmpdd.push(this.resultData.stand[i]["insurer"]);
        			tmpdd.push(this.resultData.stand[i]["year"]);
        			this.tabData.push(tmpdd);
	        		this.resultData.standSum["year"] = this.resultData.standSum["year"]+this.resultData.stand[i]["year"];
	        		this.resultData.industry["year"] = this.resultData.industry["year"]+this.resultData.stand[i]["year"];
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.standSum["insurer"]));
	        tmpdd.push(this.toBld(this.resultData.standSum["year"]));	        
	        this.tabData.push(tmpdd);
	        tmpdd = [];
       		tmpdd.push(this.toBld("Specialised Insurers"));
       		for(let i=0;i<this.totRows-1;i++){
       			tmpdd.push("");
       		}
       		this.tabData.push(tmpdd);
	        for(let i=0;i<this.resultData.spl.length;i++){
	        		tmpdd = [];
        			tmpdd.push(this.resultData.spl[i]["insurer"]);
        			tmpdd.push(this.resultData.spl[i]["year"]);
        			this.tabData.push(tmpdd);
	        		this.resultData.splSum["year"] = this.resultData.splSum["year"]+this.resultData.spl[i]["year"];
	        		this.resultData.industry["year"] = this.resultData.industry["year"]+this.resultData.spl[i]["year"]
	        }
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.splSum["insurer"]));
	        tmpdd.push(this.toBld(this.resultData.splSum["year"]));	        
	        this.tabData.push(tmpdd);
	        tmpdd = [];
	        tmpdd.push(this.toBld(this.resultData.industry["insurer"]));
	        tmpdd.push(this.toBld(this.resultData.industry["year"]));	        
	        this.tabData.push(tmpdd);
        }
         //console.log(this.resultData);
         this.showDownload=true;
      } 
    });
    
  }
  
  
  exportToExcel() {
	var currentdate = new Date(); 
	var curTimeStr = currentdate.getDate() + "/"
	    + (currentdate.getMonth()+1)  + "/" 
	    + currentdate.getFullYear() + "_"  
	    + currentdate.getHours() + "_"  
	    + currentdate.getMinutes() + "_" 
	    + currentdate.getSeconds();
	var details = this.dataType.replace(" ","_")+"-Data_Report-";
	if(this.dataType == "Segment"){  
		details = details+this.fileYear;
	} else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
		details = details+this.filefYear;
	} else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){  
		details = details+this.filefYear;
	}
	const ws: xlsx.WorkSheet =   
	xlsx.utils.table_to_sheet(this.epltable.nativeElement);
	const wb: xlsx.WorkBook = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, ws, this.dataType);
	xlsx.writeFile(wb, details+'_'+curTimeStr+'.xlsx');
 }
}

